import React, { useState, useRef } from 'react'
import { string, bool, func, oneOfType, object } from 'prop-types'
import { useOnClickOutside } from '../../../helpers/hooks'
import { DEFAULT_FUNC } from '../../../utils/constants'
import Button from '../button/Button'
import Icon from '../icon/Icon'

const emptyDropdown = { parentElement: {} }

const Dropdown = ({
  label = '',
  activeButton,
  onClickShow = DEFAULT_FUNC,
  onClickReset = DEFAULT_FUNC,
  children,
  iconName = '',
  innerLabelHTML = false,
  forceOpen = false,
  setForceOpen
}) => {
  const [show, setShow] = useState(forceOpen)
  const [position, setPosition] = useState('')
  const dropdown = useRef(emptyDropdown)
  const onClose = () => {
    if (forceOpen) {
      window.adInsights.e('search-project-cat-flyout', 'click', 'close')
      setForceOpen(false)
    }
    setShow(false)
  }
  useOnClickOutside(dropdown, onClose)
  const onReset = e => {
    onClickReset(e)
    show ? onClose() : setShow(true)
  }
  const onShow = () => {
    if (dropdown) {
      try {
        const { parentElement, offsetLeft } = dropdown.current
        const scrolledPosition = offsetLeft - parentElement.scrollLeft
        setPosition(scrolledPosition)
      } catch (error) {
        throw new Error(`Something went wrong: ${error}`)
      }
    }
    onClickShow(!show)
    show ? onClose() : setShow(true)
  }

  return (
    <div className='ad-dropdown' ref={dropdown}>
      {activeButton
        ? <Button onClick={onReset} active={activeButton || show} withIcon>
          {innerLabelHTML
            ? <span dangerouslySetInnerHTML={{ __html: label }} />
            : <span className='ad-dropdown__label'>{label}</span>
          }
          <Icon svg='cancelCircle' withoutFill />
        </Button>
        : <Button onClick={onShow} active={activeButton || show}>
          {iconName && <Icon svg={iconName} withoutFill />}
          {label}
        </Button>}
      {show || forceOpen ? children(onClose, position) : null}
    </div>
  )
}

Dropdown.propTypes = {
  label: oneOfType([string, object]),
  iconName: string,
  activeButton: bool,
  onClickReset: func,
  children: func,
  innerLabelHTML: bool,
  onClickShow: func,
  setForceOpen: func,
  forceOpen: bool
}

export default React.memo(Dropdown)
